import React from 'react';
import PageTop from '../../../core/components/PageTop';
import Panel from '../../../core/components/Panel';
import { useCpOrderInvoicesInit } from './pagehooks/useCpOrderInvoicesInit';
import CpOrderInvoicesListTable from './table/CpOrderInvoicesListTable';
import CpOrderInvoicesListSearch from './search/CpOrderInvoicesListSearch';

const PageOrdersCpOrderInvoicesList = (): JSX.Element => {
    return (
        <>
            <PageTop
                title="CP Order Invoices"
                icon="sprite-ce"
            />
            <Content />
        </>
    );
};

const Content = (): JSX.Element => {
    const init = useCpOrderInvoicesInit();

    if (!init) {
        return <></>;
    }

    return (
        <div className="cp-order-invoices-feature cp-order-invoices-list">
            <Panel
                flexDirection="column"
                noMinHeight
            >
                <CpOrderInvoicesListSearch />
                <CpOrderInvoicesListTable
                    isExternalFlyOutOpen={false}
                    showTableViewEditor
                />
            </Panel>
        </div>
    );
};

export default PageOrdersCpOrderInvoicesList;
